import PropTypes from 'prop-types';
import React from 'react';

import {
  FlexRow,
  MarketingButton,
  StyledFormItem,
} from 'common/styles/oc-styled-components';

export const InsuranceStepSubmitButton = ({
  text,
  isDisabled,
  onClick,
  isLoading,
  testId,
}) => (
  <StyledFormItem margintop="1em">
    <FlexRow justify="center">
      <MarketingButton
        type="primary"
        shape="round"
        size="large"
        block
        maxwidth="335px"
        disabled={isDisabled}
        onClick={onClick}
        htmlType={onClick ? 'button' : 'submit'}
        loading={isLoading}
        data-testid={testId}
      >
        {text}
      </MarketingButton>
    </FlexRow>
  </StyledFormItem>
);

InsuranceStepSubmitButton.propTypes = {
  text: PropTypes.string.isRequired,
  isDisabled: PropTypes.bool,
  onClick: PropTypes.func,
  isLoading: PropTypes.bool,
  testId: PropTypes.string,
};
